var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-3"},[_c('user-menu',{staticClass:"mb-3"})],1),_c('div',{staticClass:"col-sm-12 col-md-9"},[_vm._t("user-profile")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }